import { useEffect, useState } from "react";

const ExpertProductAside = ({
    categories = [],
    selectedCategory = "",
    selectedSubCategory = "",
    onCategorySelect,
}) => {
    const [expandedValues, setExpandedValues] = useState([]);

    useEffect(() => {
        const parent = categories.find((category) =>
            category.children?.some((child) => child.value === selectedSubCategory)
        );
        if (parent && !expandedValues.includes(parent.value)) {
            setExpandedValues((prev) => [...prev, parent.value]);
        }
    }, [categories, selectedSubCategory]);

    const toggleExpand = (value) => {
        setExpandedValues((prev) =>
            prev.includes(value) ? prev.filter((v) => v !== value) : [...prev, value]
        );
    };

    const handleFlatSelect = (e, value) => {
        e.preventDefault();
        onCategorySelect?.(value, "");
    };

    const handleSubSelect = (e, parentValue, subValue) => {
        e.preventDefault();
        onCategorySelect?.(parentValue, subValue);
    };

    const isFlatActive = (value) =>
        selectedCategory === value && !selectedSubCategory;

    const isParentActive = (category) => {
        if (category.children?.length) {
            return (
                selectedCategory === category.value ||
                category.children.some((child) => child.value === selectedSubCategory)
            );
        }
        return isFlatActive(category.value);
    };

    return (
        <aside className="section-aside">
            <div className="section-aside-title">
                <h5>전문가 서비스</h5>
            </div>
            <ul className="section-aside-menu pc-only">
                {categories.map((category) => {
                    const hasChildren = category.children?.length > 0;
                    const isExpanded = expandedValues.includes(category.value);

                    if (!hasChildren) {
                        return (
                            <li
                                key={category.value || "all"}
                                className={isFlatActive(category.value) ? "active" : ""}
                            >
                                <a
                                    href="#/"
                                    onClick={(e) => handleFlatSelect(e, category.value)}
                                >
                                    {category.name}
                                </a>
                            </li>
                        );
                    }

                    return (
                        <li
                            key={category.value}
                            className={isParentActive(category) ? "active" : ""}
                        >
                            <div
                                className={`section-aside-menu-tit${
                                    isExpanded ? " active" : ""
                                }`}
                                onClick={() => toggleExpand(category.value)}
                            >
                                <span>{category.name}</span>
                                <i className="icon icon-arrow-down"></i>
                            </div>
                            <ul
                                className="section-asdie-depth"
                                style={isExpanded ? { display: "flex" } : undefined}
                            >
                                {category.children.map((child) => (
                                    <li
                                        key={child.value}
                                        className={
                                            selectedSubCategory === child.value ? "active" : ""
                                        }
                                    >
                                        <a
                                            href="#/"
                                            onClick={(e) =>
                                                handleSubSelect(e, category.value, child.value)
                                            }
                                        >
                                            {child.name}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </li>
                    );
                })}
            </ul>
        </aside>
    );
};

export default ExpertProductAside;
